<ul class="nav">
  <span class="sm-flex sm-items-center sm-font-medium sm-px-2">Lists</span>
  <div
    class="sm-flex sm-items-center sm-py-3 sm-pr-1 sm-gap-2"
    *ngIf="selectedItemIds?.length === 0"
    data-test="state-toggle"
  >
    <cc-state-toggle
      #stateToggle
      [theme]="stateToggleTheme"
      [defaultValue]="viewingListsInToggledState"
      class="sm-bg-grey-3"
    >
      <cc-state-toggle-item value="active" [routerLink]="['../active']" data-test="active-templates-toggle"
        ><div class="sm-flex sm-items-center sm-space-x-1">
          <i class="cc-icon cc-icon-folder-open-solid" aria-hidden="true"></i>
          <span i18n>Active</span>
        </div>
      </cc-state-toggle-item>
      <cc-state-toggle-item
        value="archived"
        [routerLink]="['../archived']"
        data-test="archived-templates-toggle"
      >
        <div class="sm-flex sm-items-center sm-space-x-1">
          <i class="cc-icon cc-icon-archive" aria-hidden="true"></i>
          <span i18n>Archived</span>
        </div>
      </cc-state-toggle-item>
    </cc-state-toggle>
    <cc-state-toggle #stateToggle class="sm-bg-grey-3 sm-pointer-events-none">
      <cc-state-toggle-item value="grid"
        ><div class="sm-flex sm-items-center sm-space-x-1">
          <i class="cc-icon cc-icon-grid" aria-hidden="true"></i>
          <span i18n>Grid</span>
        </div>
      </cc-state-toggle-item>
    </cc-state-toggle>
  </div>
  <li
    class="nav-item mr-auto"
    *ngIf="selectedItemIds?.length > 0 && viewingListsInToggledState === itemStates.Active"
  >
    <a
      id="manage-lists-deployment"
      class="nav-link actions action-button sm-space-x-1"
      (click)="startDeployMode()"
      *ngIf="canDeployLists && selectedItemIds?.length === 1"
      ><i class="cc-icon cc-icon-nav-heirarchy d-inline-block"></i><span>Manage Deployment</span></a
    >
    <a
      id="bulk-deploy-lists"
      class="nav-link actions action-button sm-space-x-1"
      (click)="startDeployMode()"
      *ngIf="canDeployLists && selectedItemIds?.length > 1"
      ><i class="cc-icon cc-icon-nav-heirarchy d-inline-block"></i><span>Deploy</span></a
    >
    <a
      id="bulk-undeploy-lists"
      class="nav-link actions action-button sm-space-x-1"
      (click)="startUndeployMode()"
      *ngIf="canDeployLists && selectedItemIds?.length > 1"
      ><i class="cc-icon cc-icon-block red d-inline-block"></i><span>Undeploy</span></a
    >
    <a
      id="archive-selected-lists"
      class="nav-link actions action-button sm-space-x-1"
      (click)="archiveSelectedItems.emit()"
    >
      <i class="cc-icon cc-icon-archive" aria-hidden="true"></i> <span>Archive</span>
      <cc-badge
        theme="dark"
        data-test="archive-badge"
        customClasses="sm-ml-1"
        [text]="archiveBannerMetadata.type"
        [featureKey]="archiveBannerKey"
        ccBadgeLogic
      ></cc-badge>
    </a>
    <!-- Can clear after January 4th 2024 -->
    <!-- i18n is unnecessary in this case since the banner will be removed in a couple months, and we won't implement internationalization before then -->
  </li>
  <li
    class="nav-item mr-auto"
    *ngIf="selectedItemIds?.length > 0 && viewingListsInToggledState === itemStates.Archived"
  >
    <a
      id="restore-selected-lists"
      class="nav-link actions action-button sm-space-x-1"
      (click)="restoreSelectedItems.emit()"
      ><i class="cc-icon cc-icon-undo d-inline-block"></i><span>Restore</span></a
    >
    <a
      id="delete-selected-lists"
      class="nav-link actions action-button sm-space-x-1"
      (click)="deleteSelectedItems.emit()"
      ><i class="cc-icon cc-icon-delete red d-inline-block"></i><span>Delete</span></a
    >
  </li>
  <li
    class="nav-item ml-auto"
    *ngIf="selectedItemIds?.length === 0 && viewingListsInToggledState === itemStates.Active && (isProjectControllerOrAbove$ | async)"
  >
    <button
      type="button"
      data-cy="new-list"
      class="btn nav-btn-success rounded-0 action-button add-list"
      (click)="createNewItem.emit()"
    >
      Add List
    </button>
  </li>
</ul>
